import { render, staticRenderFns } from "./InvoiceAnalysis.vue?vue&type=template&id=bd9f718a"
import script from "./InvoiceAnalysis.vue?vue&type=script&lang=js"
export * from "./InvoiceAnalysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports